import * as Yup from 'yup';

export type TFormValues = {
  password: string;
  repeated: string;
};

export const initialValues: TFormValues = {
  password: '',
  repeated: '',
};

export const validationSchema = Yup.object().shape({
  password: Yup.string()
    .required('validation.required')
    .min(8, 'validation.min8')
    .matches(/^(?=.*[A-Z])/, 'validation.one_uppercase')
    .matches(/^(?=.*[a-z])/, 'validation.one_lowercase')
    .matches(/^(?=.*[0-9])/, 'validation.one_number'),
  repeated: Yup.string()
    .required('validation.required')
    .test('password-match', 'validation.password_match', function (v: any) {
      return this.parent.password === v;
    }),
});
